@if (widgetData(); as data) {
  <onyx-widget-box [heading]="data.heading" [color]="data?.color ?? 'gray'">
    <div class="content">
      <p>{{ data.content | translate }}</p>

      @if (data?.isPast && data?.delay; as delay) {
        <p class="f-danger">+{{ delay }}d</p>
      }
    </div>
  </onyx-widget-box>
}
